/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_DocsInputs */

const en_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const zh_hans1_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档`)
};

const pt_br2_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const es_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const fr_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs`)
};

const de_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doku`)
};

const ru_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документация`)
};

const it_nav_docs = /** @type {(inputs: Nav_DocsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentazione`)
};

/**
* | output |
* | --- |
* | "Docs" |
*
* @param {Nav_DocsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const nav_docs = /** @type {((inputs?: Nav_DocsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_DocsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_nav_docs(inputs)
	if (locale === "pt-BR") return pt_br2_nav_docs(inputs)
	if (locale === "es") return es_nav_docs(inputs)
	if (locale === "fr") return fr_nav_docs(inputs)
	if (locale === "de") return de_nav_docs(inputs)
	if (locale === "ru") return ru_nav_docs(inputs)
	if (locale === "it") return it_nav_docs(inputs)
	return en_nav_docs(inputs)
});